/* eslint react/jsx-key: off */
import React from 'react';
import PropTypes from 'prop-types';
import { Show, SimpleShowLayout, TextField, ReferenceField } from 'react-admin'; // eslint-disable-line import/no-unresolved

import PackageTitle from './PackageTitle';

const PackageShow = ({ permissions, ...props }) => (
    <Show title={<PackageTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="qty" />
            <TextField source="qtyInBox" />
            <TextField source="box_weight" />
            <TextField source="box_size" />
            <ReferenceField label="User" source="appUserId" reference="appusers">
                <TextField source="username" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);

PackageShow.propTypes = {
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    permissions: PropTypes.string,
};

export default PackageShow;
